import { InfoList } from 'mol-ui';
import React from 'react';
import { StatisticsLayout } from 'views/components';
import { downloadHeaders } from './fixtures';
import { isLocked } from 'shared/utils';
import { statisticsActions } from 'core/Statistics';
import { useTranslation } from 'react-i18next';
import {
    Col,
    Container,
    Row
} from './styled';
import {
    useDispatch,
    useSelector
} from 'hooks';

const StatisticsTurns = () => {
    
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { user } = useSelector('account');
    const {
        loading,
        turns: {
            online = [],
            presential = [],
            totals: {
                absent = [],
                cancelled = [],
                finalized = [],
                pending = []
            } = {}
        } = {},
        turnsDownload,
        turnsDownloading
    } = useSelector('statistics');

    const onFiltersChange = filters => {
        dispatch(statisticsActions.getStatisticsTurns(filters));
    };

    const downloadController = {
        data: turnsDownload,
        downloading: turnsDownloading,
        fileName: t('Turnos'),
        headers: downloadHeaders,
        onDownload: filters => dispatch(statisticsActions.getStatisticsTurnsDownload(filters))
    };

    return (
        <StatisticsLayout
            downloadController={ !isLocked(user, 'download_reports') ? downloadController : undefined }
            loading={ loading }
            title={ t('Turnos') }
            onFiltersChange={ onFiltersChange }
        >
            <Container>
                <Row>
                    <Col md="4">
                        <InfoList
                            icon="computer"
                            items={ online }
                            title={ t('Online') }
                        />
                    </Col>
                    <Col md="4">
                        <InfoList
                            icon="apartment"
                            items={ presential }
                            title={ t('Presencial') }
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md="3">
                        <InfoList
                            icon="pending"
                            items={ pending }
                            title={ t('Pendientes') }
                        />
                    </Col>
                    <Col md="3">
                        <InfoList
                            icon="close"
                            items={ cancelled }
                            title={ t('Cancelados') }
                        />
                    </Col>
                    <Col md="3">
                        <InfoList
                            icon="person_off"
                            items={ absent }
                            title={ t('Ausentes') }
                        />
                    </Col>
                    <Col md="3">
                        <InfoList
                            icon="check"
                            items={ finalized }
                            title={ t('Atendidos') }
                        />
                    </Col>
                </Row>
            </Container>
        </StatisticsLayout>
    );
};

export default StatisticsTurns;
